module.exports = __webpack_public_path__ + "media/images/press_kit/aman_at_sea/email/banner-7dfbe6bfe71b21b15d1b332b8cac1588.jpg";